export { default as KYCPage } from './KYCPage';
export { default as PartnerKYCPage } from './PartnerKYCPage';
